"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkButton = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("./Button");
var Text_1 = require("./Text");
var colors_1 = require("./utils/colors");
/**
 * A component for anchor tags styled as a button
 * @param {string} href - Anchor href link
 * @param {string=} [variant=primary] - Refer to the primary or secondary button variant
 * @param {string=} [size=medium] - Refer to the small, medium, and large button sizes
 */
var LinkButton = function (_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? "primary" : _b, _c = _a.size, size = _c === void 0 ? "medium" : _c, props = __rest(_a, ["children", "variant", "size"]);
    var secondaryThemeColor = (0, colors_1.useSecondaryThemeColor)();
    var textStyle = ["xsmall", "small"].includes(size)
        ? "uiSmall600"
        : "uiLarge600";
    return (react_1.default.createElement(Button_1.StyledButton, __assign({ as: "a", variant: variant, size: size, secondaryThemeColor: secondaryThemeColor }, props),
        react_1.default.createElement(Text_1.Text, { variant: textStyle }, children)));
};
exports.LinkButton = LinkButton;
